module.exports = __webpack_public_path__ + "static/img/default-avatar-2.84b23e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-avatar-2.png
// module id = zObv
// module chunks = 0